import { PatientMedicationAction } from "@/Common/Models/Patient/PatientEnums";
import { PatientMedicationViewState } from "./PatientMedicationView";

class PatientMedicationStateManager {
    private state: PatientMedicationViewState = null;

    public constructor(state: PatientMedicationViewState) {
        this.state = state;
    }

    public isCeaseWithReason(newKey: PatientMedicationAction = this.state.selectedActionCode): boolean {
        return [
            PatientMedicationAction.MarkAsInterrupted,
            PatientMedicationAction.AugmentAndReplace,
            PatientMedicationAction.ReduceAndReplace,
            PatientMedicationAction.MarkAsSuspended,
            PatientMedicationAction.MarkAsCancelled
        ].contains(newKey);
    }

    public isCease(newKey: PatientMedicationAction = this.state.selectedActionCode): boolean {
        return this.isCeaseWithReason(newKey)
            || newKey === PatientMedicationAction.MarkAsCompleted
            || (
                newKey === PatientMedicationAction.CompleteAndReplace
                && this.state.baseMedicationUpdate.Model.CommitDate != null
            );
    }

    public isReplace(newKey: PatientMedicationAction = this.state.selectedActionCode): boolean {
        return this.state.baseMedicationUpdate.Model.CommitDate == null
            || [
                PatientMedicationAction.AugmentAndReplace,
                PatientMedicationAction.ReduceAndReplace
            ].contains(newKey);
    }

    public includeNewMed(newKey: PatientMedicationAction = this.state.selectedActionCode): boolean {
        return this.state.baseMedicationUpdate.Model.CommitDate != null
            && (
                this.isReplace(newKey)
                || [
                    PatientMedicationAction.MarkAsSuspended,
                    PatientMedicationAction.CompleteAndReplace
                ].contains(newKey)
            );
    }

    public isBaseMed(): boolean {
        if (!this.includeNewMed() && !this.state.baseMedicationUpdate.Model.CommitDate)
            return true;
        else
            return false;
    }

    public hasValidMedicationName(): boolean {
        return this.isBaseMed()
            ? !!this.state.baseMedicationUpdate.Model.Name
            : !!this.state.newMedication.Model.Name;
    }
}

export { PatientMedicationStateManager };
